import type { Comment } from '../types'

interface CommentItemProps {
  comment: Comment
}

export function CommentItem({ comment }: CommentItemProps) {
  return (
    <div className="border-b border-slate-100 py-2">
      <div className="flex items-center justify-between text-xs text-slate-500 mb-1">
        <span className="font-medium text-slate-700">{comment.authorUserName}</span>
        <span>{new Date(comment.createdAt).toLocaleString('pl')}</span>
      </div>
      <p className="text-sm whitespace-pre-wrap">{comment.text}</p>
    </div>
  )
}
